<template>
  <div class="page-sidebar-wrapper">
    <div class="page-sidebar navbar-collapse collapse">

      <!--用户-->
      <ul class="page-sidebar-menu  page-header-fixed "
          data-keep-expanded="false"
          data-auto-scroll="true"
          data-slide-speed="200" style="padding-top: 20px;padding-bottom: 16px;"
      >
        <Auth :authority="[$USER_TYPE.beginner, $USER_TYPE.intermediate, $USER_TYPE.advanced]">
          <!--          功能-->
          <li class="nav-item menu-label">
            <i class="fa fa-th-large"></i>
            <span class="title">功能</span>
          </li>

          <!--        主题包管理  -->
          <router-link :to="{name: 'project'}"
                       tag="li"
                       active-class="open active"
                       class="nav-item">
            <a href="javascript:void(0)" class="nav-link nav-toggle">
              <span class="title">主题包管理</span>
              <span class="selected" v-if="mainMenu == 'project'"></span>
            </a>
          </router-link>

          <!--        小程序管理-->
          <router-link :to="{name: 'miniapp'}"
                       tag="li"
                       active-class="open active"
                       class="nav-item">
            <a href="javascript:void(0)" class="nav-link nav-toggle">
              <span class="title">小程序管理</span>
              <span class="selected" v-if="mainMenu == 'miniapp'"></span>
            </a>
          </router-link>

          <!--        素材管理-->
          <router-link :to="{name: 'material'}"
                       tag="li"
                       active-class="open active"
                       class="nav-item">
            <a href="javascript:void(0)" class="nav-link nav-toggle">
              <span class="title">素材管理</span>
              <span class="selected" v-if="mainMenu == 'material'"></span>
            </a>
          </router-link>
        </Auth>

        <Auth :authority="[$USER_TYPE.super]">

          <!--        审核-->
          <li class="nav-item menu-label">
            <i class="fa fa-th-large"></i>
            <span class="title">审核</span>
          </li>

          <!--        待审核主题包<-->
          <router-link :to="{name: 'projectCheck', params: {type: 'pending'}}"
                       tag="li"
                       active-class="open active"
                       class="nav-item"
                       :class="{ 'open active' : mainMenu == 'pending' }">
            <a href="javascript:void(0)" class="nav-link nav-toggle">
              <span class="title">待审核主题包</span>
              <span class="selected" v-if="mainMenu == 'pending'"></span>
            </a>
          </router-link>

          <!--        已审核主题包-->
          <router-link :to="{name: 'projectCheck', params: {type: 'audit'}}"
                       tag="li"
                       active-class="open active"
                       class="nav-item"
                       :class="{ 'open active' : mainMenu == 'audit' }">
            <a href="javascript:void(0)" class="nav-link nav-toggle">
              <span class="title">已审核主题包</span>
              <span class="selected" v-if="mainMenu == 'audit'"></span>
            </a>
          </router-link>

          <!--        待审核小程序专题-->
          <router-link :to="{name: 'miniappCheck', params: {type: 'pending'}}"
                       tag="li"
                       active-class="open active"
                       class="nav-item"
                       :class="{ 'open active' : mainMenu == 'miniappPending' }">
            <a href="javascript:void(0)" class="nav-link nav-toggle">
              <span class="title">待审核小程序专题</span>
              <span class="selected" v-if="mainMenu == 'miniappPending'"></span>
            </a>
          </router-link>

          <!--        已审核小程序专题-->
          <router-link :to="{name: 'miniappCheck', params: {type: 'audit'}}"
                       tag="li"
                       active-class="open active"
                       class="nav-item"
                       :class="{ 'open active' : mainMenu == 'miniappAudit' }">
            <a href="javascript:void(0)" class="nav-link nav-toggle">
              <span class="title">已审核小程序专题</span>
              <span class="selected" v-if="mainMenu == 'miniappAudit'"></span>
            </a>
          </router-link>

          <Admin>
            <!--        已共享主题包-->
            <router-link :to="{name: 'shared'}"
                         tag="li"
                         active-class="open active"
                         class="nav-item">
              <a href="javascript:void(0)" class="nav-link nav-toggle">
                <span class="title">已共享主题包</span>
                <span class="selected" v-if="mainMenu == 'shared'"></span>
              </a>
            </router-link>
          </Admin>
        </Auth>

        <!-- <Auth :authority="[$USER_TYPE.advanced, $USER_TYPE.super]"> -->
          <!--        统计分析-->
          <!-- <li class="nav-item menu-label">
            <i class="fa fa-pie-chart"></i>
            <span class="title">统计分析</span>
          </li> -->

          <!-- <Auth :authority="[$USER_TYPE.beginner, $USER_TYPE.intermediate, $USER_TYPE.advanced, $USER_TYPE.super]">
            <router-link :to="{name: 'project-stat'}"
                         tag="li"
                         active-class="open active"
                         class="nav-item">
              <a href="javascript:void(0)" class="nav-link nav-toggle">
                <span class="title">主题包统计</span>
                <span class="selected" v-if="mainMenu == 'projectStat'"></span>
              </a>
            </router-link>


            <router-link :to="{name: 'miniapp-stat'}"
                         tag="li"
                         active-class="open active"
                         class="nav-item">
              <a href="javascript:void(0)" class="nav-link nav-toggle">
                <span class="title">小程序专题统计</span>
                <span class="selected" v-if="mainMenu == 'miniappStat'"></span>
              </a>
            </router-link>
          </Auth> -->

           <!--        用户数统计-->

          <!-- <Auth :authority="[$USER_TYPE.advanced, $USER_TYPE.super]">
            <router-link :to="{name: 'user-stat'}"
                         tag="li"
                         active-class="open active"
                         class="nav-item">
              <a href="javascript:void(0)" class="nav-link nav-toggle">
                <span class="title">用户数统计</span>
                <span class="selected" v-if="mainMenu == 'userStat'"></span>
              </a>
            </router-link>
          </Auth> -->

            <!--        APP端数据统计-->

          <!-- <Auth :authority="[$USER_TYPE.super]">
            <router-link :to="{name: 'app-stat'}"
                         tag="li"
                         active-class="open active"
                         class="nav-item">
              <a href="javascript:void(0)" class="nav-link nav-toggle">
                <span class="title">APP端数据统计</span>
                <span class="selected" v-if="mainMenu == 'appStat'"></span>
              </a>
            </router-link>
          </Auth>
        </Auth> -->

        <!--        设置-->
        <li class="nav-item menu-label">
          <i class="fa fa-gear"></i>
          <span class="title">设置</span>
        </li>

        <!--        账号设置-->
        <router-link :to="{name: 'profile'}"
                     tag="li"
                     active-class="open active"
                     class="nav-item">
          <a href="javascript:void(0)" class="nav-link nav-toggle">
            <span class="title">账号设置</span>
            <span class="selected" v-if="mainMenu == 'setting'"></span>
          </a>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script type="text/javascript">
  import { mapState } from 'vuex'

  export default {
    computed: mapState([
      'mainMenu',
      'loginUser'
    ])
  }
</script>
